import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { UtilsService } from 'src/app/shared/utils.service';

@Component({
    selector: 'app-add-edit-subscription',
    templateUrl: './add-edit-subscription.component.html',
    styleUrls: ['./add-edit-subscription.component.scss'],
    standalone: false
})
export class AddEditSubscriptionComponent implements OnInit {
  addSubscriptionForm!: FormGroup;
  userID!: number;
  hide: boolean;
  passwordStrength: number;
  meterMessage: string;
  subscriptionsList = new Array<any>();
  selectable = true;
  removable = true;
  codes = new Array<any>();
  allCodes: any;
  selected: any;
  selectedIndex: any;
  type: string;
  id: number;
  subscription: any;
  showEmailError = false;
  addAnotherStatus = false;
  newPromotionCode = null;
  originalPromotionCode: any;

  constructor(public dialog: MatDialog, private dataService: DataService,
              public dialogRef: MatDialogRef<AddEditSubscriptionComponent>,
              private authService: AuthService, public utils: UtilsService,
              private cdRef: ChangeDetectorRef,
              @Inject(MAT_DIALOG_DATA) public data: any,) {
                this.hide = true;
                this.type = data.type;
                this.id = data.id;
                this.meterMessage = '';
                this.passwordStrength = 0;
                this.selected = null;
                this.subscription = data.subscription;
              }

  ngOnInit(): void {
    this.originalPromotionCode = this.subscription ? this.subscription.promotionCodeId : null;

    this.addSubscriptionForm = new FormGroup({
      firstName: new FormControl(this.subscription ? this.subscription.firstName : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      lastName: new FormControl(this.subscription ? this.subscription.lastName : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      phone_number: new FormControl(this.subscription ? this.subscription.phone : null, [Validators.required, Validators.minLength(7), Validators.maxLength(14)]),
      email: new FormControl(this.subscription ? this.subscription.email : null, [Validators.required, Validators.email, this.utils.isValidEmail.bind(this)], this.type === 'Edit' ? null : this.verifyEmail.bind(this)),
      promotion_code: new FormControl(this.subscription ? this.subscription.promotionCodeId : null, [Validators.required]),
      country_code: new FormControl(this.subscription ? this.subscription.countryCode : null, [Validators.required, Validators.maxLength(5)]),
      password_add: new FormControl(null, [Validators.required, Validators.pattern(/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}/)]),
      password_edit: new FormControl(null, [])
    });
    this.dataService.get('promotionCode/RetrievePromotionCodeByUserId/'+this.authService.getUserData().id+'?pageNumber=1&pageSize=1&searchKeyword=&isUsed=false').then((data: any) => {
      if (data.statusCode === 200) {
        const promotionsData = data.data.records;
        promotionsData.forEach((promotionData: any) => {
          this.newPromotionCode = promotionData.code;
        });
        if(this.type === 'Add' && this.newPromotionCode)
        {
          this.addSubscriptionForm.get('promotion_code')?.setValue(this.newPromotionCode);
          this.addSubscriptionForm.get('promotion_code')?.disable({ onlySelf: true });
        }
      } else {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Something went wrong, Please try again!',
            buttonText: 'Ok'
          }
        });
      }

    });

    const passwordControl = this.addSubscriptionForm.controls.password_edit;

    passwordControl.valueChanges.subscribe(() => {
      if (this.type === 'Edit') {
        if (passwordControl.value === "" || passwordControl.value === null) {
          passwordControl.setValidators(null);
        } else {
          this.addSubscriptionForm.get('password_edit')?.setValidators([Validators.pattern(/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}/)]);
        }
        passwordControl.updateValueAndValidity({emitEvent: false});
      }
    });
    this.cdRef.detectChanges();
  }

  async verifyEmail(form: FormControl): Promise<any> {
    if (form.value !== null) {
      const payload = {email: form.value};
      let used = {};
      this.dataService.post('auth/ValidateEmail', payload).then((data: any) => {
        if (data.statusCode === 200) {
          this.showEmailError = data.data.isValid === false;
          if (this.showEmailError){
            form.setErrors({used: true});
          }else{
            form.setErrors( null);
          }
        } else {
          this.showEmailError = true;
          used = data.data.isValid;
          form.setErrors({email: true});
        }
      });
    }else{
      form.setErrors( null);
    }
  }

  onChipClick(index: any) {
    for (let i = 0; i < this.subscriptionsList.length; i++) {
      const element = this.subscriptionsList[i];
      if (i === index && element.state === true) {
        this.subscriptionsList[i].state = false;
      } else if (i === index && element.state === false) {
        this.subscriptionsList[i].state = true;
      } else {
        this.subscriptionsList[i].state = false;
      }
    }
    if (this.subscriptionsList[index].state === true) {
      this.subscriptionsList[index].state = true;
      this.selected = this.subscriptionsList[index];
      this.selectedIndex = index;
      this.addSubscriptionForm.controls.firstName.setValue(this.selected.firstName);
      this.addSubscriptionForm.controls.lastName.setValue(this.selected.lastName);
      this.addSubscriptionForm.controls.password_add.setValue(this.selected.password);
      this.addSubscriptionForm.controls.phone_number.setValue(this.selected.phone_number);
      this.addSubscriptionForm.controls.email.setValue(this.selected.email);
      this.addSubscriptionForm.controls.promotion_code.setValue(this.selected.promotionCode);
      this.addSubscriptionForm.controls.country_code.setValue(this.selected.country_code);
    } else if (this.subscriptionsList[index].state === false) {
      this.subscriptionsList[index].state = false;
      this.selected = null;
      this.selectedIndex = null;
      this.addSubscriptionForm.controls.firstName.setValue(null);
      this.addSubscriptionForm.controls.lastName.setValue(null);
      this.addSubscriptionForm.controls.password_add.setValue(null);
      this.addSubscriptionForm.controls.phone_number.setValue(null);
      this.addSubscriptionForm.controls.email.setValue(null);
      this.addSubscriptionForm.controls.promotion_code.setValue(null);
      this.addSubscriptionForm.controls.country_code.setValue(null);
    } else {
      this.subscriptionsList[index].state = false;
      this.selected = null;
      this.selectedIndex = null;
      this.addSubscriptionForm.controls.firstName.setValue(null);
      this.addSubscriptionForm.controls.lastName.setValue(null);
      this.addSubscriptionForm.controls.password_add.setValue(null);
      this.addSubscriptionForm.controls.phone_number.setValue(null);
      this.addSubscriptionForm.controls.email.setValue(null);
      this.addSubscriptionForm.controls.promotion_code.setValue(null);
      this.addSubscriptionForm.controls.country_code.setValue(null);
    }
  }

  onStrengthChanged(strength: number) {
    if (strength === 60) {
      this.meterMessage = 'Weak password';
    } else if (strength === 80) {
      this.meterMessage = 'Normal password';
    } else if (strength === 100) {
      this.meterMessage = 'Strong password';
    } else {
      this.meterMessage = '';
    }
    this.passwordStrength = strength;
  }

  remove(code: string): void {
    const index = this.codes.indexOf(code);

    if (index >= 0) {
      if (this.subscriptionsList[index].state === true) {
        this.selected = null;
        this.selectedIndex = null;
        this.addSubscriptionForm.controls.firstName.setValue(null);
        this.addSubscriptionForm.controls.country_code.setValue(null);
        this.addSubscriptionForm.controls.lastName.setValue(null);
        this.addSubscriptionForm.controls.password_add.setValue(null);
        this.addSubscriptionForm.controls.phone_number.setValue(null);
        this.addSubscriptionForm.controls.email.setValue(null);
        this.addSubscriptionForm.controls.promotion_code.setValue(null);
      }
      this.codes.splice(index, 1);
      this.subscriptionsList.splice(index, 1);
    }
  }

  editSubscription() {
    if (this.addSubscriptionForm.valid) {
      this.subscriptionsList[this.selectedIndex] = {
        firstName: this.addSubscriptionForm.controls.firstName.value,
        lastName: this.addSubscriptionForm.controls.lastName.value,
        password: this.addSubscriptionForm.controls.password_add.value,
        phone_number: this.addSubscriptionForm.controls.phone_number.value,
        country_code: this.addSubscriptionForm.controls.country_code.value,
        email: this.addSubscriptionForm.controls.email.value,
        promotionCode: this.addSubscriptionForm.controls.promotion_code.value,
        state: false
    };
      this.codes[this.selectedIndex] = {
        firstName: this.addSubscriptionForm.controls.firstName.value,
        lastName: this.addSubscriptionForm.controls.lastName.value,
        password: this.addSubscriptionForm.controls.password_add.value,
        phone_number: this.addSubscriptionForm.controls.phone_number.value,
        country_code: this.addSubscriptionForm.controls.country_code.value,
        email: this.addSubscriptionForm.controls.email.value,
        promotionCode: this.addSubscriptionForm.controls.promotion_code.value,
        state: false
    };
      this.selected = null;
      this.selectedIndex = null;
      this.addSubscriptionForm.reset();
    }
  }

  closeDialog() {
    if (this.addSubscriptionForm.dirty && this.type === 'Add') {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  addAnother() {
    if (this.addSubscriptionForm.valid) {
      this.addAnotherStatus = false;
      this.onSubmit(true);
    } else {
      this.addSubscriptionForm.markAllAsTouched();
    }
  }

  checkEmail() {
    if (this.type === 'Edit' && this.addSubscriptionForm.controls.email.value === this.subscription.email) {
      this.addSubscriptionForm.controls.email.setAsyncValidators(null);
      this.addSubscriptionForm.controls.email.updateValueAndValidity({emitEvent: false});
      this.cdRef.detectChanges();
    } else if (this.type === 'Edit' && this.addSubscriptionForm.controls.email.value !== this.subscription.email) {
      this.addSubscriptionForm.controls.email.setAsyncValidators(this.verifyEmail.bind(this));
      this.addSubscriptionForm.controls.email.updateValueAndValidity({emitEvent: false});
      this.cdRef.detectChanges();
    }
  }

  onEdit() {
    this.addSubscriptionForm.get('password_add')?.setValue('password123');
    if(this.addSubscriptionForm.valid) {
      const formValues = this.addSubscriptionForm.getRawValue();

      const payload: any = {
        Id: parseInt(this.id.toString(), 10),
        FirstName : this.addSubscriptionForm.controls.firstName.value,
        LastName : this.addSubscriptionForm.controls.lastName.value,
        Email : this.addSubscriptionForm.controls.email.value,
        Password : this.addSubscriptionForm.controls.password_edit.value,
        Phone : (this.addSubscriptionForm.controls.phone_number.value || '').replace(/\s+/g, ''),
        CountryCode : this.addSubscriptionForm.controls.country_code.value,
      };

      const currentPromotionCode = formValues.promotion_code;
      if (currentPromotionCode !== this.originalPromotionCode) {
        payload.PromotionCode = currentPromotionCode;
      }

      this.dataService.put('distributor/EditSalesRepresentative', payload).then((data: any) => {
        if (data.statusCode === 200) {
          this.dialogRef.close(data.data);
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Success',
              type: 'Success',
              message: 'Subscription updated successfully',
              buttonText: 'Ok'
            }
          });
        }else if (data.statusCode === 625){
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Promotional Code not Correct/Available. Please enter a new Code!',
              buttonText: 'Ok'
            }
          });
        } else {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Something went wrong, Please try again!',
              buttonText: 'Ok'
            }
          });
        }
      });
    } else {
      this.addSubscriptionForm.markAllAsTouched();
    }

  }

  onSubmit( addAnother = false) {
      this.addSubscriptionForm.get('password_edit')?.setValue('password123');
      if (this.subscriptionsList.length === 0){
        if (this.addSubscriptionForm.valid) {
        const payload = {
          FirstName : this.addSubscriptionForm.controls.firstName.value,
          LastName : this.addSubscriptionForm.controls.lastName.value,
          Email : this.addSubscriptionForm.controls.email.value,
          Password : this.addSubscriptionForm.controls.password_add.value,
          Phone : (this.addSubscriptionForm.controls.phone_number.value || '').replace(/\s+/g, ''),
          CountryCode : this.addSubscriptionForm.controls.country_code.value,
          PromotionCode: this.addSubscriptionForm.controls.promotion_code.value
        };
        this.dataService.post('distributor/CreateSalesRepresentative', payload).then((data: any) => {
          if (data.statusCode === 200) {
            this.dialogRef.close({data:data.data, addAnother});

            if(addAnother){
              this.addAnotherStatus =  true;
            }
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Success',
                type: 'Success',
                message: 'Subscription added successfully',
                buttonText: 'Ok'
              }
            });

          }else if (data.statusCode === 600){
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'This email is already used. Please enter a new email!',
                buttonText: 'Ok'
              }
            });
          }else if (data.statusCode === 625){
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Promotional Code not Correct/Available. Please enter a new Code!',
                buttonText: 'Ok'
              }
            });
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
      } else {
        this.addSubscriptionForm.markAllAsTouched();
      }
    } else {
        for (let index = 0; index < this.subscriptionsList.length; index++) {
          const element = this.subscriptionsList[index];
          const payload = {
            FirstName : element.firstName,
            LastName : element.lastName,
            Email : element.email,
            Password : element.password,
            Phone : element.phone_number,
            CountryCode : element.country_code,
            PromotionCode: element.promotionCode
          };
          this.dataService.post('distributor/CreateSalesRepresentative', payload).then((data: any) => {
            if (data.statusCode === 200  && index === this.subscriptionsList.length - 1) {
              this.dialogRef.close(this.subscriptionsList);
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'Subscriptions added successfully',
                  buttonText: 'Ok'
                }
              });
            }
            else if (data.statusCode === 625){
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Error',
                  type: 'Error',
                  message: 'Promotional Code not Correct/Available. Please enter a new Code!',
                  buttonText: 'Ok',
                  closeDialogRef: true
                }
              });
            }
          });
        }
      }
    }

}
